module.exports = __webpack_public_path__ + "static/information3-6f9dfd7ed298b642dc35787e0e57b227.png";